import React, { useState, useRef, useEffect, useCallback } from "react";
import ResizeObserver from "resize-observer-polyfill";
import "./multi-line-ellipsis.scss";

interface Props {
    text: string;
    lines: number;
}
declare var window: any;
const MultiLineEllipsis = (props: Props) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [truncatedText, setTruncatedText] = useState(props.text);
    const [isTruncated, setIsTruncated] = useState(false);
    const ref = useRef(null);
    const observer = useRef(null);

    const checkOverflow = useCallback(() => {
        if (!ref.current || isExpanded) return;

        const element = ref.current;
        const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight);
        const maxHeight = lineHeight * props.lines;

        element.style.maxHeight = "none";
        element.textContent = props.text;

        requestAnimationFrame(() => {
            if (element.scrollHeight > maxHeight) {
                let newText = props.text;
                setIsTruncated(true);
                while (element.scrollHeight > maxHeight && newText.length > 0) {
                    newText = newText.slice(0, -1);
                    element.textContent = newText + "...";
                }

                setTruncatedText(newText + "...");
            } else {
                setIsTruncated(false);
            }
            element.style.maxHeight = "";
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.text, props.lines]);

    useEffect(() => {
        setTimeout(checkOverflow, 100);

        if (ref.current) {
            observer.current = new ResizeObserver(checkOverflow);
            observer.current.observe(ref.current.parentElement); // Observe the modal/container
        }

        return () => {
            if (observer.current) observer.current.disconnect();
        };
    }, [checkOverflow]);
    const onClickShowMoreButton = () => {
        if (observer.current && !isExpanded) observer.current.disconnect();
        setIsExpanded((ps) => !ps);
    };

    return (
        <div className="multiline-text-area">
            <p ref={ref} style={{ overflow: "hidden" }}>
                {isExpanded ? props.text : truncatedText}
            </p>
            {isTruncated && (
                <button className="ShowMoreButton" onClick={onClickShowMoreButton}>
                    {isExpanded ? window.translate("Label_Show_less") : window.translate("Label_Show_more")}
                </button>
            )}
        </div>
    );
};

export default MultiLineEllipsis;
